import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { emailValidator } from "../utils/app-validators";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
  public plans: any;
  public isSub: any;
  public locations: any;
  loading = false
  constructor(private route: ActivatedRoute, private spinner: NgxSpinnerService, public authenticationService: AuthenticationService, public router: Router) { }

  ngOnInit(): void {
    localStorage.removeItem('plan');
    localStorage.removeItem('criteria')
    this.route.queryParams.subscribe(params => {
      this.isSub = params['isSub'];
    });
    this.getSubscriptionList(this.isSub);
    // this.getLocation();
  }
  gAfterViewInit(): void { this.spinner.show(); }
  public getSubscriptionList(val): void {
    this.spinner.show();
    this.authenticationService.getPlan(val).subscribe(
      (response: any) => {
        this.plans = response['data'];
        console.log(response, 'testing')
        this.loading = true
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }


  selectedPlan(plan) {
    localStorage.setItem('plan', JSON.stringify(plan));
    if (this.isSub == 'true') {
      this.router.navigateByUrl('/base-payment');
    } else if (this.isSub === 'false') {
      this.router.navigateByUrl('/select-criteria');
    }
  }
  
  redirectTo() {
    this.router.navigateByUrl('/dashboard');
  }
}

